import EmailConfirmation from './EmailConfirmation';

export default EmailConfirmation;
